export default "__VITE_ASSET__eH5Ch21w__"